import React from 'react';
import GenerateRollNo from './Generate_RollNo';
import '../../CommonCSS/SocietyCSS.css'

const GenerateRollNoApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Generate Roll No.</h5>
          </div>
        </div>
        <GenerateRollNo />
      </div>
    </div >
  );
};

export default GenerateRollNoApp;
